/* eslint-disable import/prefer-default-export */
export const couponPath = '/print/coupon/';
